<template>
  <div data-component="agent-picker">
    <agent-picker-input
      :avatar="avatar"
      :agent="agent"
      :label="label"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      @click="isOpen = true"
    />

    <or-modal
      data-popup="agent-picker"
      :is-open="isOpen"
      @close="isOpen = false"
    >
      <template #header>
        {{ popupLabel || $t('hitl.modules.agent-picker.popup-title') }}
      </template>

      <base-agent-list
        :avatar="avatar"
        :agents="agents"
        :statuses="statuses"
        :default-search-options="defaultSearchOptions"
        :rule-groups="ruleGroups"
        :size="size"
        :use-search="true"
        :use-search-options="true"
        :use-default-action="true"
        :can-change-search-options="canChangeSearchOptions"
        :is-disabled="isDisabled"
        @item-click="onItemClick"
      />
    </or-modal>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { OrModalV3 as OrModal } from '@onereach/ui-components-25';

import AgentPickerInput from './AgentPickerInput.vue';
import { BaseAgentList } from './common';
import { IAgent } from '@/types';
import {
  AVATAR_PROP,
  AGENT_PROP,
  AGENTS_PROP,
  AGENT_SEARCH_OPTIONS_PROP,
  RULE_GROUPS_PROP,
  SIZE_PROP,
} from '../constants';

export default defineComponent({
  name: 'AgentPicker',
  components: {
    AgentPickerInput,
    BaseAgentList,
    OrModal,
  },
  props: {
    avatar: AVATAR_PROP,
    agent: AGENT_PROP,
    agents: AGENTS_PROP,
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    popupLabel: {
      type: String,
      default: '',
    },
    canChangeSearchOptions: {
      type: Boolean,
      default: true,
    },
    statuses: {
      type: Array,
      default: () => [],
    },
    defaultSearchOptions: AGENT_SEARCH_OPTIONS_PROP,
    ruleGroups: RULE_GROUPS_PROP,
    size: SIZE_PROP,
    isDisabled: Boolean,
  },
  emits: ['agent-change'],
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    onItemClick(agent: IAgent) {
      this.$emit('agent-change', agent);
      this.isOpen = false;
    },
  },
});
</script>

<style lang="scss">
/* TODO: Add scoped styles and update breakpoints to match UI Next */
[data-popup='agent-picker'] {
  @media (min-width: 900px) {
    height: 40rem;
  }

  .or-modal-content {
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
  }
}
</style>
